import { Injectable } from '@angular/core';

declare global {
  interface Window {
    MathJax: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class MathService {
  parseMath(htmlStatement: string): string {
    if (!htmlStatement) return '';
    return (
      '<tekman-math class ="tekman-math">' +
      htmlStatement
        .replace(new RegExp('\\$tekbegininline\\$', 'g'), '<span ngNonBindable> $tek$ ')
        .replace(new RegExp('\\$tekendinline\\$', 'g'), ' $tek$ </span>')
        .replace(new RegExp('\\$tekbegin\\$', 'g'), '<span class="mathJax__tekbegin--display" ngNonBindable> $tek$ ')
        .replace(new RegExp('\\$tekend\\$', 'g'), ' $tek$ </span>') +
      '</tekman-math>'
    );
  }

  renderMath() {
    setTimeout(() => {
      const node = document.getElementById('mathContent');
      window.MathJax.typesetClear([node]);
      window.MathJax.startup.promise.then(() => {
        window.MathJax.typesetPromise();
      });
    }, 0);
  }
}
